import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { BehaviorSubject, Observable,EMPTY  } from 'rxjs';
import * as tus from 'tus-js-client';
import { expand, map } from 'rxjs/operators';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
    providedIn: 'root'
})
export class VimeoService {

    private api = 'https://api.vimeo.com/me/videos';

    //It's advised not to hardcode the API token, instead fetch it from the server after authentication.
    private accessToken = '4c53476954957f15ca7988caa4955c31';

    videoList: [any]|FileList;
    videoLinks = [];
    pendingFiles: uploadFiles[] = [];

    progressCallback:Function;
    successCallback:Function;
    urlCallback:Function;

    vimeoObsShare: Observable<string>;
    vimeoResult: string;

    private vimeoCallback = new BehaviorSubject<any>([]);
    vimeoCallback$ = this.vimeoCallback.asObservable();



    private vimeoLink = new BehaviorSubject('');
    vimeoLinkObs = this.vimeoLink.asObservable();

    constructor(private http: HttpClient) { 
    }

    createVideo(file: File): Observable<any> {
        const body = {
            name: file.name,
            upload: {
                approach: 'tus',
                size: file.size
            },
            privacy: { 
                embed : 'public',
                view : 'disable',
                download : true
            },
            embed : {
              buttons : {
                share : true,
                like : false,
                embed : false,
                watchlater : false,
                fullscreen : true,
                scaling : true,
              },
              logos : {
                vimeo : false
              },
              title : {
                name : 'hide',
                owner : 'hide',
                portrait : 'hide'
              },
              volume : true
            }
        };
        
        const header: HttpHeaders = new HttpHeaders()
          .set('Authorization', 'bearer ' + this.accessToken)
          .set('Content-Type', 'application/json')
          .set('Accept', 'application/vnd.vimeo.*+json;version=3.4');
        return this.http.post(this.api, body, {
          headers: header,
          observe: 'response'
        });
      }

    getVideos(user) {
        return this.http.get('https://vimeo.com/api/v2/' + user + '/videos.json');

        //https://api.vimeo.com/users/{user_id}/videos
    }

    async getEmbedLink(url) {
        return await this.http.get('https://vimeo.com/api/oembed.json?url='+encodeURI(url));

    }

    getAlbums(user) {
        return this.http.get('https://vimeo.com/api/v2/' + user + '/albums.json');
    }

    public tusUpload(
        file: uploadFiles,
        i: number,
        videoArray: uploadFiles[],
        uploadArray: tus.Upload[],
        success: any,
      ): tus.Upload {
        const upload = new tus.Upload(file.video, {
          uploadUrl: file.uploadURI,
          endpoint: file.uploadURI,
          retryDelays: [0, 1000, 3000, 5000],
          onError: error => {
            this.vimeoCallback.next({action:'error', file : file});
            console.log('Failed: ' + file.video.name + error);
          },
          onProgress: (bytesUploaded, bytesTotal) => {
            const percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
            this.vimeoCallback.next({action:'progress', file : file, percentage : percentage});

            this.progressCallback({
              loaded : bytesUploaded,
              total : bytesTotal
            });

            /*console.log(
              'file: ' + i + ' of ' + (videoArray.length - 1) + ':',
              bytesUploaded,
              bytesTotal,
              percentage + '%'
            );*/
          },
          onSuccess: () => {
            console.log(upload);
            this.vimeoCallback.next({action:'success', file : file, url : upload.url});
            this.successCallback(file);

            //console.log('Download' + file.video.name + 'from ' + upload.url);
            if (i < videoArray.length - 1) {
              uploadArray[i + 1].start();
            } else {
              success(file);
              //console.log('Videos uploaded successfully');
            }
          }
        });
        return upload;
    }

    getLink = (video: File, index, arr) => {
        //console.log('index: ' + index);
        return this.createVideo(video).pipe(
          map(response => {
            const videoFile = new uploadFiles(video, response.body.link, response.body.upload.upload_link);
            this.pendingFiles.push(videoFile);
            this.urlCallback(response); 
            return {
              data: response,
              index: index + 1,
              arr: arr
            };
          })
        );
      }

    async videoUpload() {
        const success = () => {
          //console.log('after video upload section');
        };
        const upload: Array<any> = [];
        for (let i = 0; i < this.pendingFiles.length; i++) {
          upload.push(
            this.tusUpload(
              this.pendingFiles[i],
              i,
              this.pendingFiles,
              upload,
              success
            )
          );
        }
        //console.log('start video upload sequentially');
        return await upload[0].start();
    }

    public async start(files: [any]|FileList, options: any) {
        let videoList = files;
        //console.log(this.videoList);

        this.progressCallback = options?.progressCallback || null;
        this.urlCallback = options?.urlCallback || null;
        this.successCallback = options?.successCallback || null;

        const recursion = this.getLink(videoList[0], 0, videoList).pipe(expand(res => {
          return res.index > res.arr.length - 1 ?
          EMPTY : this.getLink(videoList[res.index], res.index, videoList);
        }));
    
        return await recursion.subscribe(async x => {
            if (x.index > x.arr.length - 1) {
                //console.log('Link generated, Starting upload');
                // All links have been generated now you can start the upload
                return await this.videoUpload();
            }
        });
      }

}

// Filename: upload.compopnent.ts
export class uploadFiles {
    constructor(public video: File, public path: string, public uploadURI: string) {
      this.video = video;
      this.path = path;
      this.uploadURI = uploadURI;
    }
}